<template>
  <li
    v-if="post && routeTo"
    :class="liClasses"
  >
    <RouterLink
      :to="routeTo"
      :class="routerLinkClasses"
      :title="htmlDecode(`Go to: ${post.title}`)"
      :tabindex="allowTabbing ? '' : '-1'"
    >
      <HotspotDemo
        :type-styles="typeClasses"
        :is-contentspot="isContentspot"
        :icon-slug="icon"
      />
      <span
        :class="spanClasses"
        v-html="post.title"
      />
    </RouterLink>
  </li>
</template>

<script>
import HotspotDemo from '@/components/HotspotDemo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SlideoutLi',

  components: {
    HotspotDemo
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    },
    allowTabbing: {
      type: Boolean,
      default: true
    },
    isContentspot: {
      type: Boolean,
      default: null
    },
    routeTo: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: ''
    },
  },

  computed: {
    // Store
    ...mapGetters([
      'routeName',
      'myStore',
    ]),
    // Li
    liClasses() { return 'mb-0_5' },
    // Router
    routerLinkClasses() {
      const tooltipStyles = this.typeClasses.tooltip ?? false
      if (!tooltipStyles) { return }
      const gtmTypeClass = this.isContentspot ? `contentspot-${this.icon}` : 'navspot'
      return [
        // GTM
        'slideout-link',
        `slideout-link-${gtmTypeClass}`,
        // Group
        'group',
        // Padding
        'p-2',
        // Display
        'flex items-center',
        // Background
        `bg-${tooltipStyles.bg_color}`,
        // Text
        'text-body',
        // Outline
        'focus:outline-none'
      ]
    },
    // Icon
    typeClasses() { return this.myStore(['styles', (this.isContentspot ? 'contentspot' : 'navspot')]) ?? {} },
    // Text
    spanClasses() {
      const tooltipStyles = this.typeClasses.tooltip ?? false
      if (!tooltipStyles) { return }
      return [
        'w-full',
        'px-4',
        `text-${tooltipStyles.text_color}`,
        tooltipStyles.text_transform ?? ''
      ]
    }
  }
}
</script>
